export function validateRatchetBracket(data) {
  if (data.mode === undefined || data.mode === '') {
    return [false, 'No mode selected.'];
  }
  if (data.mode === 'EQUAL_INTERVAL') {
    if (
      data.targetPerBracket === undefined ||
      parseFloat(data.targetPerBracket) <= 0 ||
      isNaN(data.targetPerBracket)
    ) {
      return [
        false,
        'Ratchet Bracket target per bracket is equal to, or less than zero.',
      ];
    }
    if (
      data.stopPerBracket === undefined ||
      parseFloat(data.stopPerBracket) <= 0 ||
      isNaN(data.stopPerBracket)
    ) {
      return [
        false,
        'Ratchet Bracket stop per bracket is equal to or less than zero.',
      ];
    }
    if (
      data.qtyBasisValuePerBracket === undefined ||
      parseFloat(data.qtyBasisValuePerBracket) <= 0 ||
      isNaN(data.qtyBasisValuePerBracket)
    ) {
      if (data.qtyBasis === 'PERCENT' || data.qtyBasis === 'PROFIT') {
        if (data.trailQtyBasisValue !== 1) {
          return [
            false,
            'Ratchet Bracket quantity basis value per bracket is equal to, or less than zero and trail is not 100%.',
          ];
        }
      }
    }
  }
  return [true, ''];
}
